export const animationConfig = {
  slideDuration: 700,
  slideDelay: 100,
  slideEasing: 'easeInOutCubic' // https://easings.net/
}
